import * as actionTypes from './actionTypes'


import deliveryTrackingService from 'services/deliveryTrackingService'

export const getOrders = () => {
  return dispatch =>{
    deliveryTrackingService
    .getOrders()
    .then(data =>{
      dispatch(getOrdersSuccess(data))
    })
    .catch(err =>{
      console.log(err)
    })
  }
}

export const getOrdersSuccess = orders =>{
  return {
    type : actionTypes.GET_ORDERS_DELIVERY_TRACKING_SUCCESS,
    orders : orders
  }
}




// WEBPACK FOOTER //
// ./src/store/actions/DeliveryTracking.js